import { FullPolicyData } from 'interfaces/customerDataTypes';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { Toggle } from '../toggle';
import { ToggleMessages } from '../toggleMessages';

import './documentPrintSettings.scss';
import { toggleDocumentPrintPreferenceAction } from 'actions/toggleDocumentPrintPreferenceAction';

interface AutoRenewalSettingsProps {
  selectedPolicy: FullPolicyData;
}

const documentMessageList = [
  {
    icon: 'tree',
    text: 'Help us reduce waste and protect the environment by choosing to receive your renewal documents by email instead of post.'
  }
];

export const DocumentPrintSettings = ({ selectedPolicy }: AutoRenewalSettingsProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const authentication = useAppSelector((state) => state.authentication);
  const isToggleLoading = useAppSelector((state) => state.customerData.togglePrintDocumentsLoading);
  const isToggleError = useAppSelector((state) => state.customerData.togglePrintDocumentsError);
  const { printDocuments } = selectedPolicy;
  const { email, isAgent } = authentication;

  const handleDocumentsToggleClick = () => {
    dispatch(
      toggleDocumentPrintPreferenceAction({
        selectedPolicy,
        printPolicyDocs: !printDocuments,
        username: email,
        isAgent
      })
    );
  };

  return (
    <div className="document-print-settings" id="print-preferences">
      <h4>Renewal document preference</h4>
      <ToggleMessages messageList={documentMessageList} styles="document-print-messages" messageTitle="Go paperless" />
      <Toggle
        isToggleOn={!printDocuments}
        isToggleLoading={isToggleLoading}
        isToggleError={isToggleError}
        handleToggleClick={handleDocumentsToggleClick}
        toggleLoadingText="Updating preferences..."
        toggleLabel={printDocuments ? 'Print my documents' : 'Email my documents'}
        toggleName="document-print-switch"
      />
    </div>
  );
};
